// Copyright (c) 2026 Vigeos SASU. Tous droits réservés.
/**
 * Vocabulaire des foyers (table `clients`) et des logements (table
 * `properties`), partagé par la liste des clients, la fiche d'un foyer et celle
 * d'un établissement.
 */

// Statut d'un foyer : libellé et couleur de pastille. Couleurs du thème, jamais
// des codes : le thème pose la pastille de la charte. « secondary » est écarté :
// c'est le bleu ciel clair de la charte, dont MUI ferait un aplat vif à texte
// noir au lieu du fond teinté à 14 % des autres pastilles.
export const HOUSEHOLD_STATUSES = {
  prospect: { label: 'Prospect', color: 'default' },
  pending_payment: { label: 'En attente paiement', color: 'warning' },
  active: { label: 'Actif', color: 'info' },
  installation_scheduled: { label: 'Installation planifiée', color: 'primary' },
  live: { label: 'En ligne', color: 'success' },
  inactive: { label: 'Inactif', color: 'error' },
};

/** Nom affiché d'un foyer : la raison sociale d'une fiche professionnelle, le
 *  nom du contact payeur sinon. */
export function householdName(client) {
  if (!client) return '';
  if (client.client_type === 'professional') return client.company_name || '—';
  return [client.contact_first_name, client.contact_last_name].filter(Boolean).join(' ') || '—';
}

// Types de pièce d'un logement, mêmes valeurs que `ROOM_TYPES` du backend
// (models/property.py), dans l'ordre des listes déroulantes.
export const ROOM_TYPES = [
  { value: 'bedroom', label: 'Chambre' },
  { value: 'living_room', label: 'Salon' },
  { value: 'bathroom', label: 'Salle de bain' },
  { value: 'kitchen', label: 'Cuisine' },
  { value: 'common_area', label: 'Espace commun' },
  { value: 'entrance', label: 'Entrée' },
  { value: 'other', label: 'Autre' },
];

export const ROOM_TYPE_LABEL = Object.fromEntries(
  ROOM_TYPES.map((t) => [t.value, t.label]),
);
